import { subscribe } from '@/js/api/account.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify, showSuccessNotify } from '@/js/notification.ts';

const SUCCESS_REQUEST_TEXT = 'Ваша подписка успешно обновлена!';
export function initSubscribeForm(): void {
  const form = document.querySelector<HTMLFormElement>('.js-form-subscribe');
  if (!form) {
    return;
  }

  form.addEventListener('submit', handleSubscribeFormSubmit);

  function handleSubscribeFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    void subscribeFormAsync(form);
  }

  async function subscribeFormAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);

    try {
      const response = await subscribe(formData);
      if (response.data?.success) {
        showSuccessNotify({ text: SUCCESS_REQUEST_TEXT });
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error: unknown) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
